import './styles.scss'
import React, { useContext, useEffect, useState, useRef } from 'react'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { NavLink } from 'react-router-dom'
import { getLocalAppSettings, getLocalUserDetails } from 'Utils/LocalStorage_Handler'
import { CoffeeWebContext } from 'Context/CoffeeWebContext'
import { CoffeeWebWhiteLogoMask } from 'Assets/Icons'
import { ROUTE_STRINGS } from 'Utils/Constants'

const Menubar = () => {
  const location = useLocation()
  const userDetails = getLocalUserDetails()
  const appSettings = getLocalAppSettings()
  const { isLoading } = useContext(CoffeeWebContext)
  const dropdownRef = useRef(null)

  // const [isExploreOpen, setIsExploreOpen] = useState(false) // commented for Explore Dropdown

  useEffect(() => {
    if (appSettings?.showMenuBold === true) {
      document.documentElement.style.setProperty('--setFontWeight', 'bold')
    }

    // commented for Explore Dropdown

    // const handleOutsideClick = (event) => {
    //   if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
    //     setIsExploreOpen(false)
    //   }
    // }

    // document.addEventListener('click', handleOutsideClick)

    // return () => document.removeEventListener('click', handleOutsideClick)
  }, [])

  // commented for Explore Dropdown
  // useEffect(() => {
  //   // Close the dropdown when the route changes
  //   setIsExploreOpen(false)
  // }, [location.pathname])

  // eslint-disable-next-line
  const transformMenuUrl = (url) => '/dashboard/' + url

  const parentMenuWithSubmenus = userDetails?.menus?.find((menu) => menu.subMenuModels?.length > 0)

  return (
    <>
      {userDetails.userRole !== 5 && (
        <div className={`post_header ${isLoading ? 'is-loading' : ''}`} data-testid="menu-main-container">
          <div className="" id="navbar-main" data-testid="navbar-main-container">
            <div>
              <div aria-controls="basic-navbar-nav" />
              <div id="basic-navbar-nav" data-testid="basic-navbar-container">
                <ul className="navbar-nav" data-testid="navbar-ul-container">
                  {/* Main Menus */}
                  {userDetails?.menus !== null &&
                    userDetails?.menus
                      .filter((ele) => !userDetails?.menu?.some((sub) => sub.menuUrl === ele.menuUrl))
                      .map((ele, index) => (
                        <div key={index}>
                          {ele.isWebDisplayEnable === true && ele.isLaunch === true && ele.menuUrl !== null && (
                            <li className="nav-item1 menucolor1" id="navitem" data-testid="navbar-li-container">
                              <NavLink activeClassName="active_nav-link1" exact to={transformMenuUrl(ele?.menuUrl)} className="nav-link1 nav-link-ltr">
                                <div className="menu-name-container" data-testid="menu-name-container">
                                  {ele?.menuIcon && <img src={ele.menuUrl === 'aboutUs' && !location.pathname?.includes(ROUTE_STRINGS.aboutUs) ? CoffeeWebWhiteLogoMask : ele?.menuIcon} alt="menu-image" className="menu-icon" />} {ele.menuName}
                                </div>
                              </NavLink>
                            </li>
                          )}
                        </div>
                      ))}

                  {/* Explore Dropdown Menu */}
                  {/* {parentMenuWithSubmenus?.menuName && (
                    <li
                      className="nav-item1 menucolor1 dropdown-li-explore"
                      ref={dropdownRef}
                      onClick={(e) => {
                        e.stopPropagation()
                        setIsExploreOpen((prev) => !prev)
                      }}
                    >
                      <div className="nav-link1 dropdown-toggle" data-testid="explore-menu">
                        {parentMenuWithSubmenus?.menuName}
                        <i className="pi pi-bars"></i>
                      </div>
                      {isExploreOpen && (
                        <ul className="dropdown-menu-ul" data-testid="dropdown-menus">
                          {parentMenuWithSubmenus?.subMenuModels?.map((menu) => (
                            <li key={menu.id}>
                              <NavLink exact to={transformMenuUrl(menu.menuUrl)} className="dropdown-item-navLink" onClick={() => setIsExploreOpen(false)}>
                                <div className="menu-dropdown-content">
                                  {menu.menuIcon && <img src={menu?.menuIcon} alt="menu-image" className="menu-icon" />}
                                  {menu.menuName}
                                </div>
                              </NavLink>
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  )} */}
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default Menubar
